module.exports = __webpack_public_path__ + "img/mcd-ico.4afd0191.png";